import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getPaymentStatus } from "../lib/api";
import Navbar from "../components/Navbar";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      if (attempts >= 5) {
        setStatus("timeout");
        return;
      }
      attempts++;
      try {
        const res = await getPaymentStatus(sessionId);
        if (res.data.payment_status === "paid") {
          setStatus("success");
          return;
        }
        if (res.data.status === "expired") {
          setStatus("expired");
          return;
        }
        setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 2000);
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#faf8f3" }}>
      <Navbar />
      <div className="max-w-lg mx-auto px-6 py-20 text-center" data-testid="payment-status-page">
        {status === "checking" && (
          <>
            <Loader2 className="w-16 h-16 text-[#1a6b3c] mx-auto mb-6 animate-spin" />
            <h2 className="text-2xl font-bold text-[#0d0d0d] font-['Fraunces'] mb-2">Checking payment...</h2>
            <p className="text-[#5a5a5a]">Please wait while we verify your payment.</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle className="w-16 h-16 text-[#1a6b3c] mx-auto mb-6" />
            <h2 className="text-2xl font-bold text-[#0d0d0d] font-['Fraunces'] mb-2" data-testid="payment-success-title">Payment Successful!</h2>
            <p className="text-[#5a5a5a] mb-8">Your payment has been processed successfully.</p>
            <Button data-testid="go-dashboard-btn" onClick={() => navigate("/dashboard")} className="rounded-full bg-[#c8f563] text-[#0d0d0d] hover:bg-[#b8e553] font-semibold px-8">
              Go to Dashboard
            </Button>
          </>
        )}
        {(status === "error" || status === "expired" || status === "timeout") && (
          <>
            <XCircle className="w-16 h-16 text-red-500 mx-auto mb-6" />
            <h2 className="text-2xl font-bold text-[#0d0d0d] font-['Fraunces'] mb-2">Payment Issue</h2>
            <p className="text-[#5a5a5a] mb-8">
              {status === "expired" ? "Payment session expired." : "Unable to verify payment. Please check your email for confirmation."}
            </p>
            <Button onClick={() => navigate("/dashboard")} className="rounded-full bg-[#1a6b3c] hover:bg-[#15562f] text-white px-8">
              Back to Dashboard
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
